import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-SE6D5F83VD');
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
